export default async (axios, searchValue, page, limit, params = {}) => {
    const excludePersonId = params?.excludePersonId != null
        ? Number(params.excludePersonId)
        : null;

    const response = await axios.post('/Person/GetHostListingForManagement', {
        document: '',
        groupIds: [],
        description: '',
        pageSize: limit,
        pageIndex: page,
        orderBy: ['name', 'asc'],
        name: searchValue || '',
        excludePersonId,
    });

    const { data } = response;

    return {
        metadata: {
            page: data.pageIndex,
            pages: Math.ceil(data.total / data.pageSize),
        },
        result: data.resultList
            .filter(
                item => excludePersonId == null || item.personId !== excludePersonId,
            )
            .map(item => ({
                label: item.name,
                key: item.personId,
                item,
            })),
    };
};
